import {
  AutocompleteInput,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const filterToQuery = (searchText) => ({ all: searchText });

const badDebtFilterList = (permissions) => {
  const defaultFilter = [
    // <TextInput
    //   source="all"
    //   label="mine.filter.search_all"
    //   alwaysOn
    //   resettable
    //   variant="outlined"
    //   InputProps={{
    //     endAdornment: (
    //       <InputAdornment position="end">
    //         <SearchIcon />
    //       </InputAdornment>
    //     ),
    //   }}
    // />,
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.receipt_no"
      resettable
      variant="outlined"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="date"
      label="mine.label.date"
      variant="outlined"
    />,
    <ReferenceInput
      alwaysOn
      source="customer_id"
      reference="customers"
      label="mine.label.customer"
    >
      <AutocompleteInput
        optionText="name"
        variant="outlined"
        label="mine.label.customer"
        filterToQuery={filterToQuery}
      />
    </ReferenceInput>,
    <SelectInput
      source="type"
      alwaysOn
      variant="outlined"
      label="mine.label.type"
      resettable
      choices={[
        { id: 1, name: "Bad debt" },
        { id: 2, name: "Cicilan" },
      ]}
      filterToQuery={filterToQuery}
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default badDebtFilterList;
